import * as React from "react";

import { Button, Typography } from "@material-ui/core";
import fb from "src/resources/fb.png";
import portalIconSW from "src/resources/themedportal-icon-small-white.png";
import portalLogoSW from "src/resources/themedportal-logo-small-white.png";
import twitter from "src/resources/twitter.png";

interface IProps {
  short?: boolean;
}

export class Footer extends React.Component<IProps> {
  public render() {
    const copyright = new Date().getFullYear();
    const short = this.props.short ? " footer__container--short" : "";

    return (
      <div className="footer">
        <div className={`footer__container${short}`}>
          <section className="footer__column footer__location">
            <img className="footer__logo" src={portalLogoSW} />
            <Typography variant="subtitle2" color="inherit">
            </Typography>
            <Typography variant="subtitle2" color="inherit">
            </Typography>
          </section>
          <section className="footer__column footer__navigation">
            <Button color="inherit">About us</Button>
            <Button color="inherit">Learn more</Button>
            <Button color="inherit">Support</Button>
          </section>
          <section className="footer__column footer__cta">
            <Button color="inherit">Contact us</Button>
            <Button color="inherit">Join us</Button>
          </section>
          <section className="footer__column footer__social-media">
            <div>
              <img className="footer__social-media--icon" src={fb} />
            </div>
            <div>
              <img className="footer__social-media--icon" src={twitter} />
            </div>
          </section>
        </div>
        <div className="footer__copyright">
          <div className="footer__copyright--icon">
            <img src={portalIconSW} />
          </div>
          <Typography variant="subtitle2" color="inherit">
            &copy;{`${copyright} TheMedportal`}
          </Typography>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/footer/Footer.tsx